import React from 'react';

export default function CubeOutlined({ style }: { style?: React.CSSProperties; }) {
	return (
		<span role="img" aria-label="mobilier et déco" className="anticon" style={style}>
			<svg
				viewBox="0 0 24 24"
				focusable="false"
				width="1em"
				height="1em"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				aria-hidden="true"
			>
				<path d="M12 2 21 7v10l-9 5-9-5V7z" />
				<path d="M12 12l9-5" />
				<path d="M12 12v10" />
				<path d="M12 12 3 7" />
			</svg>
		</span>
	);
}
